<template>
  <router-view />
</template>

<script setup lang="ts">
// global visibility
import { useDocumentVisibility } from '@vueuse/core';
import { useOidcStore } from 'src/stores/oidc';

const oidcStore = useOidcStore();

const visibility = useDocumentVisibility();
watch(visibility, (v) => {
  if (v === 'visible') {
    console.log(
      '[oidc] starting silent renew in App based on document visibility',
    );
    oidcStore.userManager.startSilentRenew();
  }
});
</script>
